import { validatePasswordStrengthAsync } from '~/utils/passwordStrength';
export const passwordPolicyTextsPath = 'common.validation';
export async function validatePassword(password, userInputs, texts) {
    return await validatePasswordStrengthAsync(password, userInputs) || texts.passwordNotStrongEnough();
}
